import { cva } from 'class-variance-authority'

export { default as Tabs } from './Tabs.vue'
export { default as TabsContent } from './TabsContent.vue'
export { default as TabsList } from './TabsList.vue'
export { default as TabsTrigger } from './TabsTrigger.vue'

export const tabsTriggerVariants = cva(
  'tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-p-3 tw-text-base tw-font-medium tw-ring-offset-background tw-transition-all focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50',
  {
    variants: {
      variant: {
        line: 'tw-top-px tw-mx-4 tw-relative tw-border-b tw-border-transparent data-[state=active]:tw-bg-background data-[state=active]:tw-text-primary data-[state=active]:tw-border-primary',
        fill: 'tw-px-6 tw-top-px tw-relative tw-rounded-dt-md tw-border tw-border-transparent tw-border-b-border hover:tw-border-border data-[state=active]:tw-border-border data-[state=active]:tw-border-b-background data-[state=active]:tw-bg-background data-[state=active]:tw-text-primary',
        pill: 'tw-px-6 tw-relative tw-rounded-md hover:tw-text-primary data-[state=active]:tw-bg-primary/10 data-[state=active]:tw-text-primary'
      }
    },
    defaultVariants: {
      variant: 'line'
    }
  }
)
